import { Box } from '@mui/material';
import { useCardHandlers } from '../hooks';
import { ImageOnlyCardProps } from '../types';
import { DismissButton } from './DismissButon';

export const ImageOnlyCard = ({
  card,
  onCardClick,
  onCardDismiss
}: ImageOnlyCardProps) => {
  const { imageUrl, dismissible, url } = card;
  const { handleCardClick, handleDismiss } = useCardHandlers({
    card,
    onCardClick,
    onCardDismiss
  });

  return (
    <Box
      sx={{
        cursor: url ? 'pointer' : 'default',
        position: 'relative',
        p: 0,
        mb: 4
      }}
      onClick={handleCardClick}
    >
      {dismissible && <DismissButton onClick={handleDismiss} />}
      {imageUrl && (
        <Box
          component="img"
          src={imageUrl}
          alt={imageUrl || 'Content card image'}
          sx={{
            width: '100%'
          }}
        />
      )}
    </Box>
  );
};
